import gql from 'graphql-tag';

export const LIPPER_RANKING_TABLE = gql`
    query LipperRankingTable($ticker: String!) {
        mutualFund(ticker: $ticker) {
            lipperRanking {
                oneYearAverageAnnualTotalReturnsRankDesc
                threeYearAverageAnnualTotalReturnsRankDesc
                fiveYearAverageAnnualTotalReturnsRankDesc
                tenYearAverageAnnualTotalReturnsRankDesc
                sinceInceptionTotalReturnsRankDesc
                asOfDate
            }
            inceptionDate
        }
    }
`;
